import axios from "axios";
import { API } from "./api";

// Sound + web-push helpers. Sound preference is per device (localStorage), push is per device subscription.
const SOUND_KEY = "csm_sound";
let ctx;
let last = 0;

export const soundOn = () => localStorage.getItem(SOUND_KEY) !== "0";
export const setSoundOn = (v) => localStorage.setItem(SOUND_KEY, v ? "1" : "0");

export function unlockAudio() {
  try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); if (ctx.state === "suspended") ctx.resume(); } catch {}
}

export function playChime(force = false) {
  if ((!force && !soundOn()) || Date.now() - last < 1200) return;
  last = Date.now();
  try {
    unlockAudio();
    const t = ctx.currentTime;
    [[880, 0], [1318.5, 0.13]].forEach(([f, d]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t + d);
      g.gain.exponentialRampToValueAtTime(0.25, t + d + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + d + 0.45);
      o.connect(g).connect(ctx.destination);
      o.start(t + d); o.stop(t + d + 0.5);
    });
    navigator.vibrate?.(120);
  } catch {}
}

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const b64ToBytes = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export async function currentSub() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush(api) {
  if (!pushSupported()) throw new Error(isIOS() && !isStandalone() ? "On iPhone, first add the app to your Home Screen, then turn on notifications from inside the app." : "This browser does not support notifications.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked. Allow them in your browser or phone settings for this site.");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await axios.get(`${API}/push/key`);
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.key) });
  }
  const j = sub.toJSON();
  await api("post", "/push/subscribe", { endpoint: j.endpoint, keys: j.keys });
  await api("put", "/me/prefs", { push: true });
}

export async function disablePush(api) {
  const sub = await currentSub();
  if (sub) {
    await api("post", "/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
}
